import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { ReactComponent as Check } from '../Img/icon-check.svg';
import {NotificationManager} from 'react-notifications';

const UploadTamponSignature = (props) =>
{
    const green = '#59B44A';
    const purple = '#6571FE';
    
    const [tampon, setTampon] = useState(null);
    const [organisme, setOrganisme] = useState(null);
    const [aff, setAff] = useState(false);

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            // Stocke l'image sous forme de base64 pour prévisualisation
            const reader = new FileReader();
            reader.onload = (e) => {
                setTampon(e.target.result);
            };
            reader.readAsDataURL(file);
            await setAff(!aff);
        }
    };

    async function mount()
    {    
        const params = {
            'getOrganismes': true,
            'id': props.user.id_organisme
        }
        await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params))
        .then(async (res) => {
            await setTampon(res.data[0].tampon_signature);
            await setOrganisme(res.data[0]);
        })
        .catch((err) => {
            console.warn(err)
        })
    }


    useEffect(() => {
        mount();
    }, [])


    async function validation()
    {
        if (tampon !== null && organisme !== null)
        {
            const params = {
                'updateOrganisme': true,
                'id': organisme.id,
                'tampon_signature': tampon
            }
            await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params))
            .then(async (res) => {
                if (res.data['status'] === 1) {
                    NotificationManager.success(res.data['status_message'], '', 2000);
                }
                else {
                    NotificationManager.warning(res.data['status_message'], '', 5000);
                }
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }
    

    return (
        <div className='shadow-xl' style={{textAlign: 'center', width: '90%', height: '100%',  borderRadius: 3, padding: 5, margin: 1, backgroundColor: 'white'}}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 20 }}>
                <div>
                    <p style={{fontWeight: 'bold', fontSize: 16, color: purple}}>Tampon de signature</p>
                </div>

                {/* Champ d'upload caché */}
                <input
                    id="upload-tampon-input"
                    type="file"
                    accept="image/png, image/jpeg"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                />
                
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 25, height: 200}}>
                    <img style={{maxWidth: '100%', maxHeight: '100%', borderRadius: 5}} src={tampon} />
                </div>

                {(props.user.id_type_users == '1' || props.user.id_type_users == '2') &&
                <div style={{margin: 10, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                    <button
                        className='shadow-md rounded-md'
                        style={{
                            backgroundColor: purple,
                            color: 'white',
                            fontSize: 17,
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                            padding: 10,
                            margin: 10
                        }}
                        onClick={() => document.getElementById('upload-tampon-input').click()}
                    >
                        <p>Importer</p>
                    </button>

                    <button
                    style={{
                        margin: 10,
                        display: 'flex',
                        color: 'white',
                        backgroundColor: green,
                        borderRadius: 5,
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onClick={() => {
                        validation();
                    }}
                    >
                        <div
                        style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                            paddingLeft: 10,
                            paddingRight: 10
                        }}>
                            <Check width="12" />
                            <p style={{marginLeft: 5}}>Valider</p>
                        </div>
                    </button>
                </div>
                }
            </div>
        </div>
    );
}

export default UploadTamponSignature;
